import { render, staticRenderFns } from "./ManufactorShopPage.vue?vue&type=template&id=61169142&scoped=true&"
import script from "./ManufactorShopPage.vue?vue&type=script&lang=js&"
export * from "./ManufactorShopPage.vue?vue&type=script&lang=js&"
import style0 from "./ManufactorShopPage.vue?vue&type=style&index=0&id=61169142&lang=scss&scoped=true&"
import style1 from "./ManufactorShopPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61169142",
  null
  
)

export default component.exports